import $ from 'jquery';
import axios from 'axios';
import Numeral from 'numeral';
import { createAlert } from './dom/window';
import React from 'react';
import Axios from 'axios';

// react
export const isInsideReactComponent = ($el) => {
    if ($el.closest('.react-component').length) return true;
    return false;
};

// selectrize
export const isInsideSelectrize = ($el) => {
    if ($el.closest('.selectize-control').length) return true;
    return false;
};

// Assign fonts based on editor or nlis mode

export const preferredFontsFamily = (tagType = '', fonts, IsNLIS) => {
    const updatedFonts = [];

    if (isInGodMode()) {
        return fonts;
    }

    if (tagType === 'nlis' && IsNLIS === true) {
        // Only allow Overpass extra bold
        let overpassExtraBold = fonts.find(
            (font) => font.label === 'Overpass Extra Bold'
        );
        if (overpassExtraBold) {
            updatedFonts.push(overpassExtraBold);
        }

        // updatedFonts.push(fonts[2], fonts[3]);
        return updatedFonts;
    } else {
        return fonts;
    }
};

// localStorage
export const storageAvailable = (type) => {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return (
            e instanceof DOMException &&
            // everything except Firefox
            (e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0
        );
    }
};

// use default value
export const assignValueOrDefault = (value, defaultValue) => {
    return typeof value != 'undefined' ? value : defaultValue;
};

// converters
export const convertToBoolean = (string) => {
    if (typeof string === 'boolean') return string;
    if (typeof string === 'number') return Boolean(string);
    if (typeof string === 'string' && string.length === 1)
        return Boolean(Number(string));
    if (typeof string === 'string' && string.length !== 1)
        return string.toLowerCase() === 'true';
    return false;
};

// formaters
export const formatCurrency = (value, decimal, sections) => {
    let re =
        '\\d(?=(\\d{' +
        (sections || 3) +
        '})+' +
        (decimal > 0 ? '\\.' : '$') +
        ')';
    return value
        .toFixed(Math.max(0, ~~decimal))
        .replace(new RegExp(re, 'g'), '$&,');
};

export const generateZeros = (string) => {
    let aux = '';
    for (let i = 0; i < string.length; i++) {
        aux += '0';
    }
    return aux;
};

export const calculatePercentage = (a, b) => {
    let value;

    a = Number(a);
    b = Number(b);

    if (a == 0) {
        value = 0;
    } else {
        value = parseFloat(((a - b) / a) * 100);
    }

    if (isNaN(value)) {
        value = 0;
    }

    return `${value.toFixed(2)} %`;
};

// handle default AJAX response
export const handleDefaultAJAXResponse = (response, callback) => {
    const successCallback =
        typeof callback.success != 'undefined' ? callback.success : null;
    const errorCallback =
        typeof callback.error != 'undefined' ? callback.error : null;
    const alwaysCallback =
        typeof callback.always != 'undefined' ? callback.always : null;

    console.log(response);

    if (response.status) {
        // segment tracking
        // if (typeof(response.segment) !== 'undefined' && response.segment) {
        //     SegmentTracking.trigger(response.segment);
        // }
        if (response.message) {
            // create alert
            createAlert(response, 'success');
        }

        if (response.url) {
            window.location.href = response.url;
            return;
        }

        // Callbacks
        if (successCallback) successCallback(response);
        if (alwaysCallback) alwaysCallback(response);
    } else {
        // create alert
        createAlert(response, 'error');

        // Callbacks
        if (errorCallback) errorCallback(response);
        if (alwaysCallback) alwaysCallback(response);
    }
};

export const handleDefaultAJAXPISAResponse = (response, callback) => {
    const successCallback =
        typeof callback.success != 'undefined' ? callback.success : null;
    const errorCallback =
        typeof callback.error != 'undefined' ? callback.error : null;
    const alwaysCallback =
        typeof callback.always != 'undefined' ? callback.always : null;

    console.log(response.data.payForInvoice);

    if (response.data.payForInvoice.Status) {
        // segment tracking
        // if (typeof(response.segment) !== 'undefined' && response.segment) {
        //     SegmentTracking.trigger(response.segment);
        // }
        // if (response.message) {
        //     // create alert
        //     createAlert(response, 'success');
        // }
        if (window.localeCountry == 'South Africa') {
            console.log(
                'response================',
                JSON.parse(response.data.payForInvoice.PayFastResponseData)
            );
            const payfastReadAbleData = JSON.parse(
                response.data.payForInvoice.PayFastResponseData
            );
            const jsonSetUpString = JSON.stringify(payfastReadAbleData.data.setup)
            if (payfastReadAbleData) {
                document.clear();
                document.body.innerHTML += `<form id="submitForm" action="  ${payfastReadAbleData.url} " method="post">
            <input type="hidden" name="merchant_id" value="   ${payfastReadAbleData.data.merchant_id}  " >
            <input type="hidden" name="merchant_key" value="   ${payfastReadAbleData.data.merchant_key}  ">
            <input type="hidden" name="signature" value="   ${payfastReadAbleData.data.signature}  ">
            <input type="hidden" name="notify_url" value="  ${payfastReadAbleData.data.notify_url}  ">
            <input type="hidden" name="cancel_url" value="  ${payfastReadAbleData.data.cancel_url}  ">
            <input type="hidden" name="return_url" value="  ${payfastReadAbleData.data.return_url}  ">
            <input type="hidden" name="item_name" value="   ${payfastReadAbleData.data.item_name}  ">
            <input type="hidden" name="amount" value=" ${payfastReadAbleData.data.amount}   ">
            <input type="hidden" name="setup" value='  ${jsonSetUpString} '>
            <input type="hidden" name="m_payment_id" value="    ${payfastReadAbleData.data.m_payment_id}   "></form>`;
                document.getElementById('submitForm').submit();
            }
        }
        if (window.localeCountry != 'South Africa') {
            if (response.url) {
                window.location.href = response.url;
                return;
            }
        }

        // Callbacks
        if (successCallback) successCallback(response);
        if (alwaysCallback) alwaysCallback(response);
    } else {
        // create alert
        createAlert(response, 'error');

        // Callbacks
        if (errorCallback) errorCallback(response);
        if (alwaysCallback) alwaysCallback(response);
    }
};


export const handleDefaultAJAXSAResponse = (response, callback) => {
    const payFastBaseUrl = 'https://sandbox.payfast.co.za/eng/proces';
    const successCallback =
        typeof callback.success != 'undefined' ? callback.success : null;
    const errorCallback =
        typeof callback.error != 'undefined' ? callback.error : null;
    const alwaysCallback =
        typeof callback.always != 'undefined' ? callback.always : null;

    console.log(response);

    if (response.status) {
        // segment tracking
        // if (typeof(response.segment) !== 'undefined' && response.segment) {
        //     SegmentTracking.trigger(response.segment);
        // }
        if (response.message) {
            // create alert
            createAlert(response, 'success');
        }
        if (window.localeCountry == 'South Africa') {
            console.log(
                'response================',
                JSON.parse(response.PayFastResponseData)
            );
            const payfastReadAbleData = JSON.parse(
                response.PayFastResponseData
            );
            const jsonSetUpString = JSON.stringify(payfastReadAbleData.data.setup)
            if (payfastReadAbleData) {
                document.clear();
                document.body.innerHTML += `<form id="submitForm" action="  ${payfastReadAbleData.url} " method="post">
            <input type="hidden" name="merchant_id" value="   ${payfastReadAbleData.data.merchant_id}  " >
            <input type="hidden" name="merchant_key" value="   ${payfastReadAbleData.data.merchant_key}  ">
            <input type="hidden" name="signature" value="   ${payfastReadAbleData.data.signature}  ">
            <input type="hidden" name="notify_url" value="  ${payfastReadAbleData.data.notify_url}  ">
            <input type="hidden" name="cancel_url" value="  ${payfastReadAbleData.data.cancel_url}  ">
            <input type="hidden" name="return_url" value="  ${payfastReadAbleData.data.return_url}  ">
            <input type="hidden" name="item_name" value="   ${payfastReadAbleData.data.item_name}  ">
            <input type="hidden" name="amount" value=" ${payfastReadAbleData.data.amount}   ">
            <input type="hidden" name="setup" value='  ${jsonSetUpString} '>
            <input type="hidden" name="m_payment_id" value="    ${payfastReadAbleData.data.m_payment_id}   "></form>`;
                document.getElementById('submitForm').submit();
            }
        }
        if (window.localeCountry != 'South Africa') {
            if (response.url) {
                window.location.href = response.url;
                return;
            }
        }

        // Callbacks
        if (successCallback) successCallback(response);
        if (alwaysCallback) alwaysCallback(response);
    } else {
        // create alert
        createAlert(response, 'error');

        // Callbacks
        if (errorCallback) errorCallback(response);
        if (alwaysCallback) alwaysCallback(response);
    }
};

// fetch
export const param = (a) => {
    var s = [];
    var add = function (k, v) {
        v = typeof v === 'function' ? v() : v;
        v = v === null ? '' : v === undefined ? '' : v;
        s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
    };
    var buildParams = function (prefix, obj) {
        var i, len, key;

        if (prefix) {
            if (Array.isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    buildParams(
                        prefix +
                        '[' +
                        (typeof obj[i] === 'object' && obj[i] ? i : '') +
                        ']',
                        obj[i]
                    );
                }
            } else if (String(obj) === '[object Object]') {
                for (key in obj) {
                    buildParams(prefix + '[' + key + ']', obj[key]);
                }
            } else {
                add(prefix, obj);
            }
        } else if (Array.isArray(obj)) {
            for (i = 0, len = obj.length; i < len; i++) {
                add(obj[i].name, obj[i].value);
            }
        } else {
            for (key in obj) {
                buildParams(key, obj[key]);
            }
        }
        return s;
    };
    return buildParams('', a).join('&');
};
export const getFormData = (object) => {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
};
export const handleFetchErrors = (response) => {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
};
export const fetchJSONData = (url, config, data, callback) => {
    const defaultConfig = {
        method: 'POST',
        body: param(data), // body: getFormData(data),
        credentials: 'include',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
    };
    fetch(url, {
        ...defaultConfig,
        ...config,
    })
        .then(handleFetchErrors)
        .catch((error) => console.error('Error:', error))
        .then((res) => res.json())
        .then(callback);
};

// axios
export const handleAuthenticationRequired = (message) => {
    $('#login-modal').modal('show');
};
export const handleErrorMessage = (message) => {
    if (
        message &&
        (message.toLowerCase() == 'authentication required' ||
            message.toLowerCase() == 'access denied' ||
            message.toLowerCase() == 'access forbidden')
    ) {
        handleAuthenticationRequired(message);
        return true;
    }
    return false;
};
export const handleAxiosErrors = (error) => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.message, error.request);
        if (handleErrorMessage(error.message)) return;
    } else {
        // Something happened in setting up the request that triggered an Error
        if (handleErrorMessage(error.message)) return;
        createAlert(
            {
                message: error.message,
            },
            'error'
        );

        console.error(error.message);

        return;
    }

    createAlert({}, 'error');
    // console.log(error.config);
};
export const axiosInstance = axios.create();
axiosInstance.interceptors.response.use((response) => {
    if (response.data.errors) {
        throw response.data.errors[0];
    }
    return response;
});

export const prefixLeadingZeros = 4;
export const consequeceLeadingZeros = 5;

export const zeroPad = (num, places) => String(num).padStart(places, '0');

export const calculateLeadingZeros = (value, size) => {
    if (String(Number(value)) > size) {
        value = String(Number(value)).substring(0, size);
        value = zeroPad(Number(value), size);
    } else {
        value = zeroPad(Number(value), size);
    }

    return value;
};

export const currencyDisplay = (
    price,
    currencyDisplayCode = '',
    currencyFormat,
    locale = 'en'
) => {
    if (locale && locale.includes('en')) {
        return `${currencyDisplayCode || ''} ${Numeral(price).format(
            currencyFormat
        )}`;
    } else {
        return `${Numeral(price).format(
            currencyFormat
        )} ${currencyDisplayCode || ''}`;
    }
};

/* should be refactored from template data */
export const currencyObject = {
    currencyDisplayCode:
        typeof window.currencyDisplayCode != 'undefined'
            ? window.currencyDisplayCode
            : 'AU$',
    currencyFormat:
        typeof window.currencyFormat != 'undefined'
            ? window.currencyFormat
            : '0,0.00',
    locale: typeof window.locale != 'undefined' ? window.locale : 'en_AU',
};

export const regionCurrencyObject = {
    currencyDisplayCode:
        typeof window.regionCurrencyDisplayCode != 'undefined'
            ? window.regionCurrencyDisplayCode
            : 'AU$',
    currencyFormat:
        typeof window.regionCurrencyFormat != 'undefined'
            ? window.regionCurrencyFormat
            : '0,0.00',
    locale: typeof window.locale != 'undefined' ? window.locale : 'en_AU',
};

/* should be refactored from template data */
export const __currencyDisplay = (price) => {
    const { currencyDisplayCode, currencyFormat, locale } = currencyObject;
    return currencyDisplay(price, currencyDisplayCode, currencyFormat, locale);
};

export const __regionCurrencyDisplay = (price) => {
    const {
        currencyDisplayCode,
        currencyFormat,
        locale,
    } = regionCurrencyObject;
    return currencyDisplay(price, currencyDisplayCode, currencyFormat, locale);
};

/**
 * This is used on DEBUGGER mode on tag editor
 *
 * @returns {boolean|number}
 */
export const isInGodMode = () =>
    typeof window.godMode != 'undefined' && window.godMode == 1;
